import { useRouter } from 'next/router';
import React, { MouseEvent } from 'react';
import { AngleLeftCircle, LinkButton, LinkButtonType } from '@lifechurch/react-ion';
import { SpaceProps } from 'styled-system';
import { useTranslation } from 'next-i18next';
import { LogicalProps } from '@lifechurch/react-ion/logical';

interface Props extends SpaceProps, LogicalProps {
  blockNavigation?: boolean;
  href?: string;
}

const BackButton: React.FC<Props> = ({ blockNavigation = false, href, ...spaceProps }) => {
  const { t } = useTranslation('common');

  const router = useRouter();

  const handleBack = (e: MouseEvent): void => {
    e.preventDefault();

    if (blockNavigation) return;

    if (href) {
      router.push(href);
    } else {
      router.back();
    }
  };

  return (
    <LinkButton
      href={blockNavigation ? '#' : undefined}
      onClick={handleBack}
      buttonType={LinkButtonType.SECONDARY}
      withIcon
      {...spaceProps}
    >
      <AngleLeftCircle marginInlineEnd={2} /> {t('back')}
    </LinkButton>
  );
};

export default BackButton;
